module.exports = __webpack_public_path__ + "static/media/forward.1851a3e0.png";